<template>
  <div class="container">
    <div class="elevator" id="elevator">
      <div class="iconHover" style="margin-top: 20px;">
        <img class="icon1" src="@/assets/icon/form.png" @click="dialogVisible = true"
          style="width:60px;height:60px;box-shadow: 0 0 6px 1px #999999;;border-radius: 50%;" />
        <img class="icon2" src="@/assets/icon/formA.png" @click="dialogVisible = true"
          style="width:60px;height:60px;box-shadow: 0 0 6px 1px #999999;;border-radius: 50%;" />
      </div>
      <div class="iconHover" style="margin-top: 20px;">
        <img class="icon1" src="@/assets/icon/phone.png"
          style="width:60px;height:60px;box-shadow: 0 0 6px 1px #999999;;border-radius: 50%;" />
        <img class="icon2" src="@/assets/icon/phoneA.png"
          style="width:60px;height:60px;box-shadow: 0 0 6px 1px #999999;;border-radius: 50%;" />
      </div>
      <div class="iconHover" style="margin-top: 20px;">
        <img class="icon1" @click="handleScrollTop" src="@/assets/icon/top.png"
          style="width:60px;height:60px;box-shadow: 0 0 6px 1px #999999;;border-radius: 50%;" />
        <img class="icon2" @click="handleScrollTop" src="@/assets/icon/topA.png"
          style="width:60px;height:60px;box-shadow: 0 0 6px 1px #999999;;border-radius: 50%;" />
      </div>
    </div>




    <el-dialog v-model="dialogVisible" header-class="headerDialog" class="customDialog" width="880"
      :before-close="handleClose" :show-close="false" style="padding: 0;">
      <div class="dialogContainer">
        <div class="left">
          <div class="title">绿链数智化云平台</div>
          <div class="form">
            <el-form ref="ruleFormRef" :model="state.form" :rules="state.rules" label-width="auto" label-position="top"
              require-asterisk-position="right" size="large">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="state.form.name" />
              </el-form-item>
              <el-form-item label="手机号" prop="phone">
                <el-input v-model="state.form.phone" maxlength="11" oninput="value=value.replace(/[^\d]/g,'')"
                  @blur="$event => { state.form.phone = Number($event.target.value) || ''; }" />
              </el-form-item>
              <el-form-item label="企业名称" prop="businessName">
                <el-input v-model="state.form.businessName" />
              </el-form-item>
              <div class="checkbox">
                <el-checkbox class="customCheckBox" v-model="state.form.myStatus" size="large" true-value="1"
                  false-value="0" fill="#46776D"></el-checkbox><span
                  style="color: #222222;font-size: 14px;margin-left: 6px;">我已经阅读并同意<span
                    style="color: #46776D;cursor: pointer;">《隐私保护协议》</span></span>
              </div>
            </el-form>

            <div class="button" @click="handleCreateContact(ruleFormRef)">立即提交</div>
          </div>
        </div>
        <div class="right">
          <div style="text-align: right;">
            <img src="@/assets/imgs/contact/close.png" style="width: 20px;height: 20px;cursor: pointer;"
              @click="dialogVisible = false">
          </div>
          <div style="font-weight: bold;font-size: 20px;color: #FFFFFF;margin-top: 30px;text-align: center;">
            报废汽车拆解工厂数字化解决方案</div>
          <div style="font-size: 14px;color: #88A7A1;text-align: center;">
            - 提质·增效·降本·增收 -</div>
          <div style="display: flex;justify-content: space-around;margin-top: 20px;">
            <div class="iconContainer">
              <img src="@/assets/imgs/contact/icon5.png" style="width: 44px;height: 44px;">
              <span>专家顾问一对一服务</span>
            </div>
            <div class="iconContainer">
              <img src="@/assets/imgs/contact/icon6.png" style="width: 44px;height: 44px;">
              <span>企业定制化解决方案</span>
            </div>
            <div class="iconContainer">
              <img src="@/assets/imgs/contact/icon7.png" style="width: 44px;height: 44px;">
              <span>POC业务验证</span>
            </div>
          </div>
          <div class="card">
            <div style="color: #222222;font-size: 14px;font-weight: bold;text-align: center;">扫码添加客服，获取<span
                style="color: #46776D;">免费试用</span></div>

            <div style="color: #555555;font-size: 12px;text-align: center;margin-top: 10px;">方案咨询<span
                style="color: #ECECEC;padding:0 5px;">|</span>预约演示<span
                style="color: #ECECEC;padding:0 5px;">|</span>价格咨询<span
                style="color: #ECECEC;padding:0 5px;">|</span>生态合作
            </div>
            <div style="text-align: center;margin-top: 10px;">
              <img src="@/assets/code/code3.png" style="width: 150px;height: 150px">
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, onUnmounted } from 'vue'
import { addContact } from '@/api/contact'
import { ElMessage } from 'element-plus'
onMounted(() => {
  window.addEventListener('scroll', handleShowElevator);
})
const ruleFormRef = ref(null)
const dialogVisible = ref(false)
const navHeight = ref(null);
const state = reactive({
  form: {
    name: '',//姓名
    businessName: "",//企业名称
    myStatus: 0,//状态
    phone: "",//手机号
  },
  rules: {
    name: [
      { required: true, message: '请输入姓名', trigger: 'blur' },
    ],
    phone: [
      { required: true, message: '请输入正确手机号', trigger: 'blur' },
    ],
    businessName: [
      { required: true, message: '请输入企业名称', trigger: 'blur' },
    ],
  },
})
//监听滚动高度
const handleShowElevator = () => {
  navHeight.value = window.scrollY;
  if (navHeight > 500) {
    document.getElementById("elevator").style.display = "flex";
  }
}
const handleScrollTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}
//提交资料
const handleCreateContact = async (formEl) => {
  if (!formEl) return
  if (state.form.myStatus != 1) ElMessage.error('请阅读并勾选隐私保护协议')
  await formEl.validate((valid, fields) => {
    if (valid) {
      addContact(state.form).then(res => {
        dialogVisible.value = false
        ElMessage.success(res.msg)
      })
    } else {
      ElMessage.error('提交失败')
    }
  })
}
</script>

<style lang="scss" scoped>
.container {
  .elevator {
    position: fixed;
    display: flex;
    flex-direction: column;
    right: 30px;
    top: 70%;
    z-index: 99;

    .iconHover .icon1 {
      display: inline-block;
      cursor: pointer;
    }

    .iconHover .icon2 {
      display: none;
      cursor: pointer;
    }

    .iconHover:hover .icon1 {
      display: none;
      cursor: pointer;
    }

    .iconHover:hover .icon2 {
      display: inline-block;
      cursor: pointer;
    }


  }

  .dialogContainer {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .left {
      width: 50%;
      height: 520px;
      background-color: #E1E9E7;
      padding: 30px;
      box-sizing: border-box;

      .title {
        width: 100%;
        color: #222222;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
      }

      .form {
        margin-top: 29px;

        .checkbox {
          display: flex;
          align-items: center;

        }

      }

      .button {
        background-color: #46776D;
        color: #FFFFFF;
        width: 120px;
        height: 44px;
        line-height: 44px;
        text-align: center;
        border-radius: 22px;
        cursor: pointer;
        margin-top: 30px;
      }
    }

    .right {
      width: 50%;
      background-image: url('@/assets/icon/bg.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      height: 520px;
      padding: 30px;
      box-sizing: border-box;

      .iconContainer {
        width: 32%;
        display: flex;
        color: #FFFFFF;
        font-size: 12px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

        span {
          margin-top: 9px;
        }
      }

      .card {
        width: 100%;
        border-radius: 8px;
        background-color: #FFFFFF;
        height: 244px;
        margin-top: 30px;
        padding: 24px;
        box-sizing: border-box;
      }
    }
  }


}
</style>
